"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _draftJs = require("draft-js");

var _isSupportedPropertyType = _interopRequireDefault(require("composer-plugins/utils/isSupportedPropertyType"));

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _QuestionAndAnswerPanel = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/editorPanel/QuestionAndAnswerPanel"));

var _BaseQuestionBlock = _interopRequireDefault(require("./BaseQuestionBlock"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _QuestionContainer = _interopRequireDefault(require("./QuestionContainer"));

var _ActionButtonsProvider = _interopRequireDefault(require("./ActionButtonsProvider"));

function handleOpenPanel(_ref) {
  var onEditorStateChange = _ref.onEditorStateChange,
      getEditorState = _ref.getEditorState,
      blockKey = _ref.blockKey,
      setPanelOpen = _ref.setPanelOpen;
  var editorState = getEditorState();

  var newSelection = _draftJs.SelectionState.createEmpty(blockKey);

  onEditorStateChange(_draftJs.EditorState.forceSelection(editorState, newSelection));
  setPanelOpen(true);
}

var EditorQuestionBlock = function EditorQuestionBlock(_ref2) {
  var blockKey = _ref2.blockKey,
      entityKey = _ref2.entityKey,
      getEditorState = _ref2.getEditorState,
      getInsertQuestionAndAnswerEnabled = _ref2.getInsertQuestionAndAnswerEnabled,
      onEditorStateChange = _ref2.onEditorStateChange,
      properties = _ref2.properties,
      property = _ref2.property,
      question = _ref2.question,
      saveQuestion = _ref2.saveQuestion;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      panelOpen = _useState2[0],
      setPanelOpen = _useState2[1];

  var alertMessage = null;
  var alertType = null;
  var propertyIsSupported = question.isPropertyQuickReply() && (0, _isSupportedPropertyType.default)(property);
  var isPropertyQuickReplyAndUnsupported = question.isPropertyQuickReply() && !propertyIsSupported;

  if (isPropertyQuickReplyAndUnsupported) {
    alertMessage = _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.notSupportedType"
    });
    alertType = 'warning';
  }

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ActionButtonsProvider.default, {
    disabled: !getInsertQuestionAndAnswerEnabled || !getInsertQuestionAndAnswerEnabled(),
    onEditClicked: function onEditClicked() {
      return handleOpenPanel({
        blockKey: blockKey,
        getEditorState: getEditorState,
        onEditorStateChange: onEditorStateChange,
        setPanelOpen: setPanelOpen
      });
    },
    onDeleteClicked: function onDeleteClicked() {
      return onEditorStateChange((0, _draftHelpers.deleteEntity)(entityKey, getEditorState()));
    },
    hideEditButton: isPropertyQuickReplyAndUnsupported
  }, _react.default.createElement(_BaseQuestionBlock.default, {
    question: question,
    objectProperty: property,
    disabled: true,
    alertMessage: alertMessage,
    alertType: alertType
  })), panelOpen && _react.default.createElement(_QuestionAndAnswerPanel.default, {
    question: question,
    properties: properties,
    saveQuestion: saveQuestion,
    onClose: function onClose() {
      return setPanelOpen(false);
    }
  }));
};

EditorQuestionBlock.propTypes = {
  blockKey: _propTypes.default.string.isRequired,
  entityKey: _propTypes.default.string.isRequired,
  getEditorState: _propTypes.default.func.isRequired,
  onEditorStateChange: _propTypes.default.func.isRequired,
  properties: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  question: _propTypes.default.instanceOf(_QuestionEntityRecord.default).isRequired,
  saveQuestion: _propTypes.default.func.isRequired,
  getInsertQuestionAndAnswerEnabled: _propTypes.default.func,
  property: _propTypes.default.instanceOf(_immutable.Map)
};

var _default = (0, _QuestionContainer.default)(EditorQuestionBlock);

exports.default = _default;
module.exports = exports.default;